/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import React from 'react';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import { useIsAuthenticated } from '@azure/msal-react';
import { SignInButton } from './SignInButton';
import { SignOutButton } from './SignOutButton';
import { Link } from 'react-router-dom';

/**
 * Renders the navbar component with a sign-in or sign-out button depending on whether or not a user is authenticated
 * @param props
 */
export const PageLayout = (props) => {
    const isAuthenticated = useIsAuthenticated();
    
    return (
        <>
            <Navbar bg="primary" variant="dark" className="navbarStyle" expand="lg">
                <Navbar.Brand as={Link} to="/">
                    Kristina's Playground
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav" className="justify-content-between">
                    {isAuthenticated && (
                        <Nav className="mr-auto">
                            <Nav.Link as={Link} to="/home">Home</Nav.Link>
                            <Nav.Link as={Link} to="/profile">Profile</Nav.Link>
                            <Nav.Link as={Link} to="/valentines2025">Valentines 2025</Nav.Link>
                            <Nav.Link as={Link} to="/birthday">Birthday 2025</Nav.Link>
                            <Nav.Link as={Link} to="/ukraine">Ukraine Trip</Nav.Link>
                            <Nav.Link as={Link} to="/tiktok-generator">TikTok Generator</Nav.Link>
                        </Nav>
                    )}
                    <div className="d-flex">
                        {isAuthenticated ? <SignOutButton /> : <SignInButton />}
                    </div>
                </Navbar.Collapse>
            </Navbar>
            {props.children}
        </>
    );
};
